import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
// Still extends HTMLElement over Component so that refs are still available to parent components (e.g. SortingFilterComponent)
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    // Stop default behaviour from the browser
    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
  };
  // /** @type {Animation|null} */
  // #animation = null;

  // handleClick = (event) => {
  //   const isMobile = isMobileBreakpoint();
  //   const isDesktop = !isMobile;

  //   if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
  //     event.preventDefault();
  //     return;
  //   }

  //   // Browser ka default rok ke smooth animation chalao
  //   event.preventDefault();
  //   this.details.open ? this.#collapse() : this.#expand();
  // };

  // #expand() {
  //   const content = this.details.querySelector('.details-content');
  //   if (!content) return;

  //   this.details.open = true;
    
  //   // Height calculate karne ke liye pehle visible karo
  //   content.style.height = '0px';
  //   content.style.overflow = 'hidden';
    
  //   const endHeight = content.scrollHeight;

  //   this.#animation?.cancel();
  //   this.#animation = content.animate(
  //     { 
  //       height: ['0px', `${endHeight}px`],
  //       opacity: [0, 1]
  //     },
  //     { duration: 300, easing: 'ease', fill: 'forwards' }
  //   );

  //   this.#animation.onfinish = () => {
  //     content.style.height = '';
  //     content.style.overflow = '';
  //     this.#animation = null;
  //   };
  // }

  // #collapse() {
  //   const content = this.details.querySelector('.details-content');
  //   if (!content) return;

  //   const startHeight = content.offsetHeight;

  //   content.style.overflow = 'hidden';

  //   this.#animation?.cancel();
  //   this.#animation = content.animate(
  //     { 
  //       height: [`${startHeight}px`, '0px'],
  //       opacity: [1, 0]
  //     },
  //     { duration: 300, easing: 'ease', fill: 'forwards' }
  //   );

  //   // details.open = false sirf animation khatam hone ke BAAD
  //   this.#animation.onfinish = () => {
  //     this.details.open = false;
  //     content.style.height = '';
  //     content.style.overflow = '';
  //     this.#animation = null;
  //   };
  // }

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      this.summary.focus();
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}
